import { createResourceStore } from "@/lib/resource";

export interface DataChange {
  id: string;
  attribute: string;
  old_value: string | number | null;
  new_value: string | number | null;
  changeable_id: string;
  changeable_type: string;
  description: string | null;
  user_id: string | null;
  created_at: string;
  updated_at: string;
  user?: any;
  changeable?: any;
}

export const useDataChange = createResourceStore<DataChange>("data-changes");
